/* ============================================================
   OCOA Side Cart — interactivity
   - Subscribe / One-time toggle  -> /cart/change.js (selling plan)
   - "Pairs Well With"            -> /recommendations/products (section render)
   - Quick Add from recommendations
   - Mobile recommendations carousel arrows
   Reuses the theme's shapes:modalcart:* events so cart-items.js /
   cart-footer.js / cart-count.js morph the DOM after every mutation.
   ============================================================ */
(function () {
  'use strict';

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      add: r.cart_add_url || '/cart/add',
      change: r.cart_change_url || '/cart/change',
    };
  }
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  function postJSON(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function fire(name, data, target) {
    document.body.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail: { response: data, originalTarget: target || null } })
    );
  }

  /* ---------- Subscribe / One-time toggle ----------
     Feels instant: on click we flip the buttons, price and saving immediately with NO
     dimming and NO waiting on the network. The /cart/change sync is DEBOUNCED so rapid
     toggles are never blocked and only the final choice is sent once the shopper settles
     (~350ms). Debouncing also means no section morph fires mid-interaction, so the line
     node + key stay valid (Shopify reassigns the line key whenever the plan changes).
     The single morph afterwards reconciles the totals + free-shipping bar. */
  var planSyncTimers = {};
  function setPlan(planEl, subscribe) {
    var key = planEl.getAttribute('data-oc-line-key');
    var planId = planEl.getAttribute('data-oc-plan-id');
    if (!key || (subscribe && !planId)) return;

    // instant optimistic UI (buttons)
    var sb = planEl.querySelector('[data-oc-plan-sub]');
    var ot = planEl.querySelector('[data-oc-plan-one]');
    if (sb && ot) {
      sb.classList.toggle('is-active', subscribe);
      ot.classList.toggle('is-active', !subscribe);
      sb.setAttribute('aria-pressed', subscribe);
      ot.setAttribute('aria-pressed', !subscribe);
    }
    // instant optimistic price + saving swap
    var line = planEl.closest('[data-cart-item-key]');
    if (line) {
      var nowSub = line.querySelector('[data-oc-now-sub]');
      var nowOne = line.querySelector('[data-oc-now-one]');
      if (nowSub) nowSub.hidden = !subscribe;
      if (nowOne) nowOne.hidden = subscribe;
      var saving = line.querySelector('[data-oc-saving]');
      if (saving) saving.hidden = !subscribe;
    }

    // debounced background sync — last click within the window wins
    clearTimeout(planSyncTimers[key]);
    planSyncTimers[key] = setTimeout(function () {
      delete planSyncTimers[key];
      var qty = 1;
      var input = line && line.querySelector('input[type="number"]');
      if (input) qty = parseInt(input.value, 10) || 1;
      postJSON(routes().change, {
        id: key,
        quantity: qty,
        selling_plan: subscribe ? planId : null,
        sections: SECTIONS,
        sections_url: window.location.pathname,
      })
        .then(function (data) {
          fire('shapes:modalcart:cartqtychange', data, line);
        })
        .catch(function () {});
    }, 350);
  }

  /* ---------- Quick Add (recommendations) ---------- */
  function quickAdd(btn) {
    var id = btn.getAttribute('data-oc-add');
    if (!id || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    btn.classList.add('is-adding');
    postJSON(routes().add, { items: [{ id: id, quantity: 1 }], sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (data) {
        fire('shapes:modalcart:afteradditem', data, btn);
        loadRecommendations();
      })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove('is-adding');
        delete btn.dataset.busy;
      });
  }

  /* ---------- Home/collection quick-add (QA #01) ----------
     The homepage "Best Sellers" cards are wrapped in a link to the PDP. The "Add To Cart"
     button carries data-oc-quickadd="<variant id>"; we intercept it, stop the link
     navigation, AJAX-add, and open the sidecart in place. */
  function openDrawer() {
    try {
      var m = window.Alpine && window.Alpine.store && window.Alpine.store('modals');
      if (!m) return;
      if (m.rightDrawer) m.rightDrawer.contents = 'cart';
      if (typeof m.open === 'function') m.open('rightDrawer', 'cart');
      if (m.rightDrawer) m.rightDrawer.contents = 'cart';
    } catch (e) {}
  }
  function homeQuickAdd(el) {
    var id = el.getAttribute('data-oc-quickadd');
    if (!id || el.dataset.ocBusy) return;
    el.dataset.ocBusy = '1';
    el.classList.add('is-adding');
    var item = { id: id, quantity: 1 };
    var plan = el.getAttribute('data-oc-quickadd-plan');
    if (plan) item.selling_plan = plan;
    postJSON(routes().add, { items: [item], sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (data) { fire('shapes:modalcart:afteradditem', data, el); openDrawer(); loadRecommendations(); })
      .catch(function () {})
      .finally(function () { el.classList.remove('is-adding'); delete el.dataset.ocBusy; });
  }

  /* ---------- delegated clicks ----------
     CAPTURE phase is required: the theme's #right-drawer-slot uses Alpine
     @click.stop (bubble-phase stopPropagation), which would otherwise prevent
     these document-level handlers from ever seeing clicks inside the drawer. */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-oc-quickadd]');
    if (qa) { e.preventDefault(); e.stopPropagation(); homeQuickAdd(qa); return; }
    var sub = e.target.closest('[data-oc-plan-sub]');
    var one = e.target.closest('[data-oc-plan-one]');
    var add = e.target.closest('[data-oc-add]');
    if (sub && !sub.classList.contains('is-active')) { e.preventDefault(); setPlan(sub.closest('[data-oc-plan]'), true); return; }
    if (one && !one.classList.contains('is-active')) { e.preventDefault(); setPlan(one.closest('[data-oc-plan]'), false); return; }
    if (add) { e.preventDefault(); quickAdd(add); }
  }, true);

  /* ---------- recommendations ----------
     Cart data is read from the rendered line items (DOM), NOT /cart.js —
     this store proxies /cart.js to HTML, so we avoid it entirely. */
  var recoBusy = false;
  var recoCache = []; // card outerHTML from the last successful fetch (persisted across re-teleports/reloads)
  try { var _rc = sessionStorage.getItem('ocoaRecoCards'); if (_rc) recoCache = JSON.parse(_rc) || []; } catch (e) {}

  function cartSeedAndIds() {
    var lines = Array.prototype.slice.call(document.querySelectorAll('.oc-line[data-oc-product-id]'));
    var inCart = {};
    lines.forEach(function (l) { inCart[l.getAttribute('data-oc-product-id')] = true; });
    var seed = lines.length ? lines[lines.length - 1].getAttribute('data-oc-product-id') : null;
    return { seed: seed, inCart: inCart };
  }
  // Fill reco mounts. force=false only fills EMPTY mounts (used on open/re-teleport so we
  // never clobber good cards); force=true refreshes with freshly fetched cards.
  function fillRecoLists(cardHTMLs, force) {
    var lists = document.querySelectorAll('[data-oc-reco-list]');
    if (!lists.length || !cardHTMLs || !cardHTMLs.length) return;
    lists.forEach(function (list) {
      if (!force && list.children.length) return;
      var isDesktop = !!list.closest('.ocoa-cart__aside');
      var slice = isDesktop ? cardHTMLs.slice(0, 3) : cardHTMLs.slice(0, 10);
      list.innerHTML = slice.join('');
      var mobileReco = list.closest('.oc-reco--mobile');
      if (mobileReco) mobileReco.style.display = slice.length ? '' : 'none';
    });
    updateRecoArrows();
  }
  function fetchReco(attempt) {
    attempt = attempt || 0;
    if (attempt === 0 && recoBusy) return;
    if (!document.querySelector('[data-oc-reco-list]')) { recoBusy = false; return; }
    var info = cartSeedAndIds();
    if (!info.seed) { recoBusy = false; return; }
    recoBusy = true;
    var url = '/recommendations/products?product_id=' + info.seed + '&limit=10&intent=related&section_id=ocoa-cart-recommendations';
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var cards = Array.prototype.slice.call(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.oc-card'))
          .filter(function (c) { var pid = c.getAttribute('data-oc-card-product'); return !pid || !info.inCart[pid]; })
          .map(function (c) { return c.outerHTML; });
        if (cards.length) {
          recoCache = cards;
          try { sessionStorage.setItem('ocoaRecoCards', JSON.stringify(cards)); } catch (e) {}
          fillRecoLists(cards, true);
          recoBusy = false;
        } else if (attempt < 2) {
          setTimeout(function () { fetchReco(attempt + 1); }, 700); // Shopify reco index can lag right after edits
        } else { recoBusy = false; }
      })
      .catch(function () { if (attempt < 2) setTimeout(function () { fetchReco(attempt + 1); }, 700); else recoBusy = false; });
  }
  // Instant: paint cached cards into any empty mount, then refresh from the network.
  function loadRecommendations() {
    syncEmptyState();
    fillRecoLists(recoCache, false);
    fetchReco(0);
  }

  // Toggle an empty-cart flag so the desktop "Pairs Well With" aside can hide when there
  // are no line items (the empty-state CTA + suggestions live in the main column instead).
  function syncEmptyState() {
    document.querySelectorAll('.ocoa-cart').forEach(function (c) {
      c.classList.toggle('oc-is-empty', !c.querySelector('.oc-line'));
    });
  }

  /* ---------- cart re-hydration on bfcache restore (QA #04) ----------
     Back/forward navigation can restore a cached page whose drawer was rendered from a
     stale (often empty) cart. Re-fetch the cart sections for the current cart and morph. */
  function rehydrateCart() {
    fetch(window.location.pathname + '?sections=' + SECTIONS, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) { fire('shapes:modalcart:cartqtychange', { sections: sections }); loadRecommendations(); })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) rehydrateCart(); });

  /* ---------- mobile recommendations carousel ---------- */
  function updateRecoArrows() {
    document.querySelectorAll('.oc-reco--mobile .oc-reco__railwrap').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-oc-reco-list]');
      var prev = wrap.querySelector('[data-oc-reco-prev]');
      var next = wrap.querySelector('[data-oc-reco-next]');
      if (!rail || !prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth;
      prev.hidden = rail.scrollLeft <= 2;
      next.hidden = rail.scrollLeft >= max - 2;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oc-reco-prev],[data-oc-reco-next]');
    if (!btn) return;
    var wrap = btn.closest('.oc-reco__railwrap');
    var rail = wrap && wrap.querySelector('[data-oc-reco-list]');
    if (!rail) return;
    var card = rail.querySelector('.oc-card');
    var step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: btn.hasAttribute('data-oc-reco-next') ? step : -step, behavior: 'smooth' });
  }, true);
  document.addEventListener('scroll', function (e) {
    if (e.target.closest && e.target.matches && e.target.matches('[data-oc-reco-list]')) updateRecoArrows();
  }, true);

  /* ---------- triggers ---------- */
  var refreshReco = function () { setTimeout(loadRecommendations, 80); };
  // cart mutations -> refetch (products may have changed)
  window.addEventListener('shapes:modalcart:afteradditem', refreshReco);
  window.addEventListener('shapes:modalcart:cartqtychange', refreshReco);
  // every drawer open (incl. re-teleport, which creates empty mounts) -> paint from cache + refresh
  window.addEventListener('right-drawer-is-open', refreshReco);
  // safety net: if the drawer is re-teleported (new empty mounts), repaint from cache immediately
  if (window.MutationObserver) {
    try {
      new MutationObserver(function () {
        var aside = document.querySelector('.ocoa-cart__aside [data-oc-reco-list]');
        if (aside && !aside.children.length && recoCache.length) fillRecoLists(recoCache, false);
      }).observe(document.body, { childList: true });
    } catch (e) {}
  }

  /* ---------- Free gift: auto-add / auto-remove at the spend threshold ----------
     Shopify's Buy-X-Get-Y discount ("Free Scalp Massager at $75") makes the item
     free once eligible, but it does NOT add the item to cart on its own — a
     shopper has to do that manually. This reads the same threshold + variant the
     cart's progress bar already displays (data-oc-massager-threshold /
     data-oc-massager-variant in ocoa-cart-items.liquid), so there's one number to
     keep in sync, not three.

     The auto-added line is tagged with a line-item property so it's never
     confused with a massager a shopper added on purpose — we only ever touch
     the line that carries our own tag. */
  var GIFT_PROP = '_ocoa_auto_gift';
  var giftChecking = false;

  function giftConfig() {
    var el = document.querySelector('[data-oc-massager-variant]');
    if (!el) return null;
    var variantId = el.getAttribute('data-oc-massager-variant');
    var threshold = parseInt(el.getAttribute('data-oc-massager-threshold'), 10);
    if (!variantId || !threshold) return null;
    return { variantId: variantId, threshold: threshold };
  }

  function findAutoGiftLine(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id) === String(variantId) && item.properties && item.properties[GIFT_PROP] === '1') {
        return item;
      }
    }
    return null;
  }

  function checkGiftThreshold() {
    if (giftChecking) return;
    var cfg = giftConfig();
    if (!cfg) return;
    giftChecking = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = findAutoGiftLine(cart, cfg.variantId);
        var subtotal = cart.items_subtotal_price;
        if (subtotal >= cfg.threshold && !line) {
          var props = {};
          props[GIFT_PROP] = '1';
          return postJSON(routes().add, {
            items: [{ id: cfg.variantId, quantity: 1, properties: props }],
            sections: SECTIONS,
            sections_url: window.location.pathname,
          }).then(function (data) { fire('shapes:modalcart:afteradditem', data); });
        }
        if (subtotal < cfg.threshold && line) {
          return postJSON(routes().change, {
            id: line.key,
            quantity: 0,
            sections: SECTIONS,
            sections_url: window.location.pathname,
          }).then(function (data) { fire('shapes:modalcart:cartqtychange', data); });
        }
      })
      .catch(function () {})
      .finally(function () { giftChecking = false; });
  }

  // Same universal events every cart-mutating flow on the site fires (PDP,
  // collection/home quick-add, cart drawer qty +/-, subscribe toggle, etc.) —
  // NOT just this file's own handlers.
  window.addEventListener('shapes:modalcart:afteradditem', function () { setTimeout(checkGiftThreshold, 60); });
  window.addEventListener('shapes:modalcart:cartqtychange', function () { setTimeout(checkGiftThreshold, 60); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkGiftThreshold);
  } else {
    checkGiftThreshold();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRecommendations);
  } else {
    loadRecommendations();
  }
})();

/* Mirror the cart drawer's open/closed state onto <body class="oc-cart-open"> so CSS can
   hide the floating third-party widgets (Gorgias chat, Quinn video reel, Klaviyo teaser)
   that otherwise stack above the drawer. The drawer's modal container stays display:block
   even when closed, so we track the reactive Alpine store (modals.rightDrawer.open), which
   flips true/false on open/close. */
(function () {
  function bind() {
    if (!(window.Alpine && Alpine.store && Alpine.store('modals') && Alpine.effect)) { return false; }
    Alpine.effect(function () {
      var s = Alpine.store('modals');
      var open = !!(s && s.rightDrawer && s.rightDrawer.open);
      document.body.classList.toggle('oc-cart-open', open);
    });
    return true;
  }
  if (!bind()) {
    document.addEventListener('alpine:initialized', bind);
    // fallback if alpine:initialized already fired before this script ran
    var tries = 0, t = setInterval(function () { if (bind() || ++tries > 40) { clearInterval(t); } }, 100);
  }
})();
